// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jRock","large":"styles_large__dQ6dL","medium":"styles_medium__FgeLi","small":"styles_small__U1bCJ","hasHeadingColor":"styles_hasHeadingColor__5wk6n"};